import SEO from "../../../../src/components/seo";
import React from 'react';
export default {
  SEO,
  React
};